<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-post-8_natanz-underground-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-post-8_natanz-underground-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.57474483707733;"
    data-aspect-ratio="0.575"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-post-8_natanz-underground-xs-img"
      class="g-post-8_natanz-underground-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-8_natanz-underground-xs.jpg);"
    ></div>
    <div
      id="g-ai0-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:12.4525%;margin-top:-7.5px;left:53.8106%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle1">IRAN</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:26.9299%;margin-top:-15.6px;right:52.5308%;width:113px;"
    >
      <p class="g-pstyle2">Natanz</p>
      <p class="g-pstyle2">nuclear facility</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:34.7673%;margin-top:-15.6px;right:67.6468%;width:106px;"
    >
      <p class="g-pstyle2">Underground</p>
      <p class="g-pstyle2">complex</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:47.0315%;margin-top:-8px;left:81.3208%;margin-left:-31.5px;width:63px;"
    >
      <p class="g-pstyle3">1000 m</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:61.9298%;margin-top:-16.6px;left:3.0154%;width:104px;"
    >
      <p class="g-pstyle4">Mountain</p>
      <p class="g-pstyle4">peak 1,608 m.</p>
    </div>
    <div
      id="g-ai0-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:7.75%;margin-top:-7.5px;left:49.0556%;width:58px;"
    >
      <p class="g-pstyle0">Natanz</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-whiteshadow g-aiAbs"
      style="top:91.2625%;left:1.7284%;width:76.3636%;"
    >
      <p class="g-pstyle7">The centrifuge halls could lie</p>
      <p class="g-pstyle8">78 - 145 metres</p>
      <p class="g-pstyle8">deep underground.</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:74.818%;margin-top:-8.6px;left:49.965%;width:128px;"
    >
      <p class="g-pstyle6">Tunnels entrances</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:64.0198%;margin-top:-16.6px;left:77.97%;margin-left:-74.5px;width:149px;"
    >
      <p class="g-pstyle5">Natanz underground</p>
      <p class="g-pstyle5">nuclear facility</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-post-8_natanz-underground-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 0.96233275505992;"
    data-aspect-ratio="0.962"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-post-8_natanz-underground-sm-img"
      class="g-post-8_natanz-underground-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-8_natanz-underground-sm.jpg);"
    ></div>
    <div
      id="g-ai1-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:10.6608%;margin-top:-7.5px;left:11.7407%;width:58px;"
    >
      <p class="g-pstyle1">Natanz</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:17.2885%;margin-top:-15.6px;right:40.5831%;width:106px;"
    >
      <p class="g-pstyle0">Underground</p>
      <p class="g-pstyle0">complex</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:15.7555%;margin-top:-7.5px;left:14.8174%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle2">IRAN</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:30.5757%;margin-top:-8px;left:91.1017%;margin-left:-31.5px;width:63px;"
    >
      <p class="g-pstyle3">1000 m</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:76.8132%;margin-top:-20.1px;left:4.302%;width:78px;"
    >
      <p class="g-pstyle6">Mountain</p>
      <p class="g-pstyle6">peak</p>
      <p class="g-pstyle6">1,608 m.</p>
    </div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:8.7973%;margin-top:-15.6px;right:30.8022%;width:113px;"
    >
      <p class="g-pstyle0">Natanz</p>
      <p class="g-pstyle0">nuclear facility</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-whiteshadow g-aiAbs"
      style="top:86.9873%;left:1.9276%;width:49.4118%;"
    >
      <p class="g-pstyle7">The centrifuge halls could lie</p>
      <p class="g-pstyle8">78 - 145 metres</p>
      <p class="g-pstyle8">deep underground.</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:42.3925%;margin-top:-16.7px;left:78.2752%;margin-left:-83.5px;width:167px;"
    >
      <p class="g-pstyle4">Natanz underground</p>
      <p class="g-pstyle4">nuclear facility</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:69.462%;margin-top:-9.1px;left:73.4985%;width:136px;"
    >
      <p class="g-pstyle5">Tunnels entrances</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-post-8_natanz-underground-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 1.11675126903553;"
    data-aspect-ratio="1.117"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-post-8_natanz-underground-md-img"
      class="g-post-8_natanz-underground-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-8_natanz-underground-md.jpg);"
    ></div>
    <div
      id="g-ai2-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:9.7289%;margin-top:-7.5px;left:9.7356%;width:58px;"
    >
      <p class="g-pstyle1">Natanz</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:14.2975%;margin-top:-7.5px;left:12.1131%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle2">IRAN</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:15.8414%;margin-top:-15.6px;right:32.5271%;width:106px;"
    >
      <p class="g-pstyle0">Underground</p>
      <p class="g-pstyle0">complex</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:27.7563%;margin-top:-8px;left:91.9567%;margin-left:-31.5px;width:63px;"
    >
      <p class="g-pstyle3">1000 m</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:71.5097%;margin-top:-17.6px;left:4.4971%;width:110px;"
    >
      <p class="g-pstyle6">Mountain</p>
      <p class="g-pstyle6">peak 1,608 m.</p>
    </div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:8.2272%;margin-top:-15.6px;right:24.9691%;width:113px;"
    >
      <p class="g-pstyle0">Natanz</p>
      <p class="g-pstyle0">nuclear facility</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-whiteshadow g-aiAbs"
      style="top:88.1557%;left:1.3326%;width:38.1818%;"
    >
      <p class="g-pstyle7">The centrifuge halls could lie</p>
      <p class="g-pstyle8">78 - 145 metres</p>
      <p class="g-pstyle8">deep underground.</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:43.2596%;margin-top:-19.7px;left:74.6802%;margin-left:-83.5px;width:167px;"
    >
      <p class="g-pstyle4">Natanz underground</p>
      <p class="g-pstyle4">nuclear facility</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:68.041%;margin-top:-9.1px;left:77.396%;width:136px;"
    >
      <p class="g-pstyle5">Tunnels entrances</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-post-8_natanz-underground-lg"
    class="g-artboard"
    style="min-width: 930px;aspect-ratio: 1.69769399711373;"
    data-aspect-ratio="1.698"
    data-min-width="930"
  >
    <div
      id="g-post-8_natanz-underground-lg-img"
      class="g-post-8_natanz-underground-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-8_natanz-underground-lg.jpg);"
    ></div>
    <div
      id="g-ai4-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:11.3328%;margin-top:-9.1px;left:7.7322%;width:64px;"
    >
      <p class="g-pstyle1">Natanz</p>
    </div>
    <div
      id="g-ai4-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:15.0598%;margin-top:-7.5px;left:9.4195%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle2">IRAN</p>
    </div>
    <div
      id="g-ai4-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:16.908%;margin-top:-15.6px;right:21.5212%;width:106px;"
    >
      <p class="g-pstyle0">Underground</p>
      <p class="g-pstyle0">complex</p>
    </div>
    <div
      id="g-ai4-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:34.5163%;margin-top:-8.1px;left:96.8254%;margin-left:-33.5px;width:67px;"
    >
      <p class="g-pstyle4">1000 m</p>
    </div>
    <div
      id="g-ai4-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:56.5209%;margin-top:-14.6px;left:0.5138%;width:116px;"
    >
      <p class="g-pstyle6">Mountain peak</p>
      <p class="g-pstyle6">1,608 m.</p>
    </div>
    <div
      id="g-ai4-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:8.6934%;margin-top:-15.6px;right:16.1574%;width:113px;"
    >
      <p class="g-pstyle0">Natanz</p>
      <p class="g-pstyle0">nuclear facility</p>
    </div>
    <div
      id="g-ai4-9"
      class="g-whiteshadow g-aiAbs"
      style="top:84.3371%;left:0.376%;width:27.0968%;"
    >
      <p class="g-pstyle7">The centrifuge halls could lie</p>
      <p class="g-pstyle8">78 - 145 metres deep underground.</p>
    </div>
    <div
      id="g-ai4-5"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:32.4473%;margin-top:-18.7px;left:50.023%;margin-left:-92.5px;width:185px;"
    >
      <p class="g-pstyle3">Natanz underground</p>
      <p class="g-pstyle3">nuclear facility</p>
    </div>
    <div
      id="g-ai4-7"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:52.7787%;margin-top:-11.1px;left:71.0159%;width:136px;"
    >
      <p class="g-pstyle5">Tunnels entrances</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-04 14:36 -->

<!-- Generated by ai2svelte v1.0.3 - 2026-03-04 14:36 -->
<!-- ai file: post-8_natanz-underground.ai -->
<style lang="scss">
  #g-post-8_natanz-underground-box {
    container-type: inline-size;
    container-name: g-post-8_natanz-underground-box;
  }
  #g-post-8_natanz-underground-box,
  #g-post-8_natanz-underground-box .g-artboard {
    margin: 0 auto;
  }
  #g-post-8_natanz-underground-box p {
    margin: 0;
  }
  #g-post-8_natanz-underground-box .g-aiAbs {
    position: absolute;
  }
  #g-post-8_natanz-underground-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-post-8_natanz-underground-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-post-8_natanz-underground-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-post-8_natanz-underground-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-post-8_natanz-underground-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-post-8_natanz-underground-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-post-8_natanz-underground-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-post-8_natanz-underground-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-post-8_natanz-underground-lg {
        display: block !important;
      }
    }
  }
  #g-post-8_natanz-underground-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-8_natanz-underground-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 15px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-8_natanz-underground-xs .g-pstyle0 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
    color: rgb(64, 64, 64);
  }
  #g-post-8_natanz-underground-xs .g-pstyle1 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-post-8_natanz-underground-xs .g-pstyle2 {
    font-weight: 400;
    height: 15px;
    text-align: right;
  }
  #g-post-8_natanz-underground-xs .g-pstyle3 {
    font-weight: 400;
    height: 15px;
    font-size: 13px;
    text-align: center;
    color: rgb(186, 186, 186);
  }
  #g-post-8_natanz-underground-xs .g-pstyle4 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    font-size: 14px;
    color: rgb(102, 102, 102);
  }
  #g-post-8_natanz-underground-xs .g-pstyle5 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    font-size: 14px;
    text-align: center;
  }
  #g-post-8_natanz-underground-xs .g-pstyle6 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    font-size: 14px;
  }
  #g-post-8_natanz-underground-xs .g-pstyle7 {
    font-weight: 400;
    line-height: 17px;
    font-size: 14px;
    color: rgb(64, 64, 64);
  }
  #g-post-8_natanz-underground-xs .g-pstyle8 {
    font-weight: 700;
    line-height: 17px;
    font-size: 14px;
    color: rgb(165, 15, 21);
  }
  #g-post-8_natanz-underground-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-8_natanz-underground-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 15px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-8_natanz-underground-sm .g-pstyle0 {
    font-weight: 400;
    height: 15px;
    text-align: right;
  }
  #g-post-8_natanz-underground-sm .g-pstyle1 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
    color: rgb(64, 64, 64);
  }
  #g-post-8_natanz-underground-sm .g-pstyle2 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-post-8_natanz-underground-sm .g-pstyle3 {
    font-weight: 400;
    height: 15px;
    font-size: 13px;
    text-align: center;
    color: rgb(186, 186, 186);
  }
  #g-post-8_natanz-underground-sm .g-pstyle4 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    font-size: 16px;
    text-align: center;
  }
  #g-post-8_natanz-underground-sm .g-pstyle5 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
  }
  #g-post-8_natanz-underground-sm .g-pstyle6 {
    font-weight: 400;
    line-height: 13px;
    height: 13px;
    font-size: 14px;
    color: rgb(102, 102, 102);
  }
  #g-post-8_natanz-underground-sm .g-pstyle7 {
    font-weight: 400;
    line-height: 20px;
    font-size: 16px;
    color: rgb(64, 64, 64);
  }
  #g-post-8_natanz-underground-sm .g-pstyle8 {
    font-weight: 700;
    line-height: 20px;
    font-size: 16px;
    color: rgb(165, 15, 21);
  }
  #g-post-8_natanz-underground-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-8_natanz-underground-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 15px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-8_natanz-underground-md .g-pstyle0 {
    font-weight: 400;
    height: 15px;
    text-align: right;
  }
  #g-post-8_natanz-underground-md .g-pstyle1 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
    color: rgb(64, 64, 64);
  }
  #g-post-8_natanz-underground-md .g-pstyle2 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-post-8_natanz-underground-md .g-pstyle3 {
    font-weight: 400;
    height: 15px;
    font-size: 13px;
    text-align: center;
    color: rgb(186, 186, 186);
  }
  #g-post-8_natanz-underground-md .g-pstyle4 {
    font-weight: 700;
    line-height: 19px;
    height: 19px;
    font-size: 16px;
    text-align: center;
  }
  #g-post-8_natanz-underground-md .g-pstyle5 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
  }
  #g-post-8_natanz-underground-md .g-pstyle6 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
    color: rgb(102, 102, 102);
  }
  #g-post-8_natanz-underground-md .g-pstyle7 {
    font-weight: 400;
    line-height: 19px;
    font-size: 16px;
    color: rgb(64, 64, 64);
  }
  #g-post-8_natanz-underground-md .g-pstyle8 {
    font-weight: 700;
    line-height: 19px;
    font-size: 16px;
    color: rgb(165, 15, 21);
  }
  #g-post-8_natanz-underground-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-8_natanz-underground-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 15px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-8_natanz-underground-lg .g-pstyle0 {
    font-weight: 400;
    height: 15px;
    text-align: right;
  }
  #g-post-8_natanz-underground-lg .g-pstyle1 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    color: rgb(64, 64, 64);
  }
  #g-post-8_natanz-underground-lg .g-pstyle2 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-post-8_natanz-underground-lg .g-pstyle3 {
    font-weight: 700;
    line-height: 18px;
    height: 18px;
    font-size: 18px;
    text-align: center;
  }
  #g-post-8_natanz-underground-lg .g-pstyle4 {
    font-weight: 400;
    height: 15px;
    font-size: 14px;
    text-align: center;
    color: rgb(163, 163, 163);
  }
  #g-post-8_natanz-underground-lg .g-pstyle5 {
    font-weight: 400;
    line-height: 21px;
    height: 21px;
  }
  #g-post-8_natanz-underground-lg .g-pstyle6 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    color: rgb(102, 102, 102);
  }
  #g-post-8_natanz-underground-lg .g-pstyle7 {
    font-weight: 400;
    line-height: 19px;
    font-size: 16px;
    color: rgb(64, 64, 64);
  }
  #g-post-8_natanz-underground-lg .g-pstyle8 {
    font-weight: 700;
    line-height: 19px;
    font-size: 16px;
    color: rgb(165, 15, 21);
  }

  /* Custom CSS */
  @mixin shadow-manchego($clr) {
    $alpha: if(alpha($clr) != 1, alpha($clr), 1);
    text-shadow:
      rgba($clr, $alpha) 1px 0px 0px,
      rgba($clr, $alpha) 0.540302px 0.841471px 0px,
      rgba($clr, $alpha) -0.416147px 0.909297px 0px,
      rgba($clr, $alpha) -0.989992px 0.14112px 0px,
      rgba($clr, $alpha) -0.653644px -0.756802px 0px,
      rgba($clr, $alpha) 0.283662px -0.958924px 0px,
      rgba($clr, $alpha) 0.96017px -0.279415px 0px;
  }

  @mixin shadow-feta($clr) {
    $alpha: if(alpha($clr) != 1, alpha($clr), 0.5);
    text-shadow:
      0 0 10px rgba($clr, $alpha),
      0 0 3px rgba($clr, $alpha);
  }

  @mixin shadow-provolone($clr) {
    $alpha: if(alpha($clr) != 1, alpha($clr), 0.7);
    text-shadow:
      1px 1px 0px rgba($clr, $alpha),
      0px 1px 0px rgba($clr, $alpha),
      -1px 1px 0px rgba($clr, $alpha),
      -1px 0px 0px rgba($clr, $alpha),
      -1px -1px 0px rgba($clr, $alpha),
      0px -1px 0px rgba($clr, $alpha),
      1px -1px 0px rgba($clr, $alpha);
  }

  @mixin shadow-gouda($clr) {
    $alpha: if(alpha($clr) != 1, alpha($clr), 0.9);
    text-shadow:
      1px 1px 1px rgba($clr, $alpha),
      1px -1px 1px rgba($clr, $alpha),
      -1px 1px 1px rgba($clr, $alpha),
      -1px -1px 1px rgba($clr, $alpha);
  }
  .g-shadow {
    @include shadow-manchego(#000000);
    @include shadow-feta(#000000);
  }
  .g-whiteshadow {
    @include shadow-provolone(#ffffff);
    @include shadow-gouda(#ffffff);
  }
</style>
